import { render, staticRenderFns } from "./inside.vue?vue&type=template&id=315c4976&scoped=true"
import script from "./inside.vue?vue&type=script&lang=js"
export * from "./inside.vue?vue&type=script&lang=js"
import style0 from "./inside.vue?vue&type=style&index=0&id=315c4976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c4976",
  null
  
)

export default component.exports